import Tool from "../Tool"

const Rotate = Tool.extend({
  bindEvents(el, activate) {
    this.editor.getElement("rotate-ccw").addEventListener("click", () => { this.execute(90); });
    this.editor.getElement("rotate-cw").addEventListener("click", () => { this.execute(270); });
  },

  execute(angle) {
    const url = this.editor.makeURL(`Act=rotate&angle=${angle}`);

    AJAX.send({
      scope: this.editor.getAJAXScope(),
      callback: (data) => {
        this.editor.setURL(data.pics.http);
        this.editor.history.push();
      },
      url
    });
  }
});

export default Rotate;
